// extracted by mini-css-extract-plugin
export default {"PostDetailRight__searchPanel":"qi_a bhk_su bhk_kv bhk_kw","PostDetailRight__brandDaysPosts":"qi_b bhk_su bhk_kv bhk_kw"};